export const Logo = ({ variant = "dark", className = "" }) => {
  const src = variant === "light" ? "/brand/logo-ondark.png" : "/brand/logo-onlight.png";
  return (
    <div className={`flex items-center ${className}`} data-testid="site-logo">
      <img src={src} alt="OffplanDubai.nl" className="h-11 w-auto" width="135" height="44" />
    </div>
  );
};
